/* bz-care-guide-pop.js: on a product page, open the matched care guide (simple/advanced)
   in an in-page modal instead of navigating to the Care Guides library.
   Markup is rendered by snippets/bz-care-guide-product-links.liquid; modal styles are
   borrowed from bz-care-guides-library.css. Falls back to the plain links if JS is off. */
(function () {
  function setup(root) {
    var modal = root.querySelector('[data-bz-guide-modal]');
    var tpls = {
      simple: root.querySelector('[data-bz-guide-tpl="simple"]'),
      advanced: root.querySelector('[data-bz-guide-tpl="advanced"]')
    };
    if (!modal || !tpls.simple || !tpls.advanced) return;

    // The modal is `position: fixed`, but a transformed/filtered ancestor (common in
    // product-page sections) would re-anchor it to that ancestor instead of the viewport,
    // making it scroll with the page and sit half off-screen. Portal it to <body> so
    // `fixed` always means "the viewport". Triggers/templates stay inside `root`.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    var content = modal.querySelector('[data-bz-guide-content]');
    var panel = modal.querySelector('.bz-care-modal__panel');
    if (!content) return;
    var lastFocus = null;

    function render(version) {
      version = version || 'advanced';
      if (!tpls[version]) version = tpls.advanced ? 'advanced' : 'simple';
      var tpl = tpls[version];
      content.innerHTML = '';
      content.appendChild(tpl.content.cloneNode(true));
      content.scrollTop = 0;
      modal.querySelectorAll('[data-bz-guide-tab]').forEach(function (b) {
        var on = b.getAttribute('data-bz-guide-tab') === version;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.classList.toggle('bz-pill--red', on);
        b.classList.toggle('bz-pill--ghost', !on);
      });
    }
    function open(version) {
      lastFocus = document.activeElement;
      render(version);
      modal.hidden = false;
      document.body.classList.add('bz-care-modal-open');
      document.documentElement.style.overflow = 'hidden';
      if (panel) panel.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('bz-care-modal-open');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Bind every [data-bz-guide-open] on the page, not just the ones inside this
    // card, so the "Open the Simple guide" link in the product lore callout (which
    // lives in a separate section) opens this modal too. If no working modal exists
    // on the page, setup() never runs, so those links keep behaving as plain links.
    document.querySelectorAll('[data-bz-guide-open]').forEach(function (a) {
      if (a.dataset.bzGuideBound) return;
      a.dataset.bzGuideBound = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        open(a.getAttribute('data-bz-guide-open'));
      });
    });
    modal.querySelectorAll('[data-bz-guide-tab]').forEach(function (b) {
      b.addEventListener('click', function () { render(b.getAttribute('data-bz-guide-tab')); });
    });
    modal.querySelectorAll('[data-bz-guide-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }
  document.querySelectorAll('[data-bz-guide-pop]').forEach(setup);
})();
